<template>
  <div class="imgItem">
    <img
      :style="{
        width:width,
        height:height
      }"
      :class="{selected:selected}"
      :src="src"
      alt="">
  </div>
</template>

<script>
export default {
  //
  name: '',
  components: {},
  props: {
    src: {
      type: String,
      require: true
    },
    width: {
      type: String,
      require: true
    },
    height: {
      type: String,
      require: true
    },
    // 是否选中
    selected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  computed: {},
  watch: {
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.imgItem{
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  .selected{
    // border: 2px solid yellow;
    border-style:solid;
    border-width: 2px;
    border-color: yellow !important;
  }
}
</style>
